import { tss } from "tss-react/mui";

export const useProductHighlightsSectionStyles = tss.withName("ProductHighlightsSection").create(({ theme }) => ({
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexWrap: "wrap" as const,
        gap: theme.spacing(2),
        marginBottom: theme.spacing(5),
    },
    overline: {
        marginBottom: theme.spacing(1.5),
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        maxWidth: 520,
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: theme.spacing(4),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(2.5),
        },
    },
}));
